/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 6/7/2023
 */

import axios from "axios"
let base64 = require("base-64")

let auth =
  "Basic " +
  base64.encode(
    process.env.REACT_APP_AUTH_USERNAME +
      ":" +
      process.env.REACT_APP_AUTH_PASSWORD
  )

const AuthInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_URL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: auth,
  },
})
export default AuthInstance
